
<cradua-auth
[getAuthError]="getAuthError$ | async"
[isLoadingLogin]="isLoadingLogin$ | async"
(emitLogin)="onLogin($event)"
></cradua-auth>
